<template>
  <div class="qc-playform-header">
    <div v-if="props.showColseBtn"
      :class="closeBtnIconClassName"
      @click="props.closeHandle">
    </div>
    <div v-if="customer.worksheet_switch" class="qc-service-btn" @click="openCustomer">
      <div class="qc-sprites qc-sprites-service_icon qc-service-icon"></div>
      <div v-if="region === REGION.DOMESTIC">客服</div>
    </div>
    <div :class="logoClassName"></div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import configManager from '../../core/config/index';
import { REGION, COMPANY_CONSTANT } from '../../core/constants/index'

interface HeaderProps {
  showColseBtn?: boolean;
  closeBtnIcon?: string;
  closeHandle?: () => void;
}

const props = withDefaults(defineProps<HeaderProps>(), {
  showColseBtn: true
});

const customer = configManager.getCustomer();
const region = configManager.get('region');
const company = configManager.getCompany();

const openCustomer = () => {
  if (!customer.worksheet_switch) {
    return;
  }
  // 跳转到客服页面
  window.open(customer.worksheet_url, '_blank');
};

const closeBtnIconClassName = computed(() => {
  if (!props.closeBtnIcon) {
    return 'qc-close-btn';
  }
  return `qc-sprites qc-sprites-${props.closeBtnIcon} qc-close-btn`;
  
});

const logoClassName = computed(() => {
  if (region === REGION.DOMESTIC) {
    return 'qc-sprites qc-sprites-logo';
  } else if (region ===  REGION.OVERSEAS) {
    switch(company) {
      case COMPANY_CONSTANT.QC_HW:
        return 'qc-sprites qc-sprites-hw_logo';
      case COMPANY_CONSTANT.TAIWAN:
        return 'qc-sprites qc-sprites-tw_logo';
      case COMPANY_CONSTANT.AUSTRALIA:
        return 'qc-sprites qc-sprites-australia_logo';
      case COMPANY_CONSTANT.VIETNAM:
        return 'qc-sprites qc-sprites-vietnam_logo';
      case COMPANY_CONSTANT.JAPAN:
        return 'qc-sprites qc-sprites-japan_logo';
      case COMPANY_CONSTANT.QC:
        return 'qc-sprites qc-sprites-logo';
      default:
        return 'qc-sprites qc-sprites-hw_logo';
    }
  } else {
    return '';
  }
});
</script>